import { render, staticRenderFns } from "./RemoveBays.vue?vue&type=template&id=071ea7b2&"
import script from "./RemoveBays.vue?vue&type=script&lang=js&"
export * from "./RemoveBays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports